import { useState } from 'react'
import { Icone } from './Icone'

/**
 * Le lien de la fiche ouverte, à donner : l'appli installée n'a pas de barre d'adresse. Ouvert
 * ailleurs (autre appareil, autre personne), il mène droit à la fiche, après la connexion s'il
 * le faut.
 */
export function CopierLien({ objet }: { objet: string }) {
  const [copie, setCopie] = useState(false)
  return (
    <button
      type="button"
      className="bouton-discret"
      onClick={async () => {
        try {
          await navigator.clipboard.writeText(window.location.href)
          setCopie(true)
          window.setTimeout(() => setCopie(false), 2500)
        } catch {
          setCopie(false)
        }
      }}
    >
      <Icone nom="link" taille={18} />
      {copie ? 'Lien copié' : `Copier le lien ${objet}`}
    </button>
  )
}
